import { render } from "./menu-usuario.vue?vue&type=template&id=6f2f0368&scoped=true"
import script from "./menu-usuario.vue?vue&type=script&lang=js"
export * from "./menu-usuario.vue?vue&type=script&lang=js"

import "./menu-usuario.vue?vue&type=style&index=0&id=6f2f0368&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f2f0368"]])

export default __exports__